export interface SortableSectionViewModel {
  [key: string]: {
    selectedHeader: string;
    headers: SortableSectionHeader[];
  };
}

export interface SortableSectionHeader {
  headerName: string;
  sortDirection: string;
  displayText?: string;
  size?: number;
  offset?: number;
}

export enum SortDirections {
  asc = 'asc',
  desc = 'desc',
}
